var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _AudiFootnoteServiceState_initialized, _AudiFootnoteServiceState_error, _AudiFootnoteServiceState_resolveIsInitialized, _AudiFootnoteServiceState_isInitializedPromise;
import { fetchData } from '../helpers/api';
import { mapToArray } from '../helpers';
class AudiFootnoteServiceState {
    constructor() {
        _AudiFootnoteServiceState_initialized.set(this, false);
        _AudiFootnoteServiceState_error.set(this, false);
        _AudiFootnoteServiceState_resolveIsInitialized.set(this, void 0);
        _AudiFootnoteServiceState_isInitializedPromise.set(this, new Promise((resolve) => (__classPrivateFieldSet(this, _AudiFootnoteServiceState_resolveIsInitialized, resolve, "f"))));
        this.apiUrls = [];
    }
    get error() {
        return __classPrivateFieldGet(this, _AudiFootnoteServiceState_error, "f");
    }
    set error(value) {
        __classPrivateFieldSet(this, _AudiFootnoteServiceState_error, value, "f");
        if (__classPrivateFieldGet(this, _AudiFootnoteServiceState_error, "f")) {
            __classPrivateFieldGet(this, _AudiFootnoteServiceState_resolveIsInitialized, "f").call(this, false);
        }
    }
    get initialized() {
        return __classPrivateFieldGet(this, _AudiFootnoteServiceState_initialized, "f");
    }
    set initialized(value) {
        __classPrivateFieldSet(this, _AudiFootnoteServiceState_initialized, value, "f");
        if (__classPrivateFieldGet(this, _AudiFootnoteServiceState_initialized, "f")) {
            __classPrivateFieldGet(this, _AudiFootnoteServiceState_resolveIsInitialized, "f").call(this, true);
        }
    }
    isInitialized() {
        return __classPrivateFieldGet(this, _AudiFootnoteServiceState_isInitializedPromise, "f");
    }
}
_AudiFootnoteServiceState_initialized = new WeakMap(), _AudiFootnoteServiceState_error = new WeakMap(), _AudiFootnoteServiceState_resolveIsInitialized = new WeakMap(), _AudiFootnoteServiceState_isInitializedPromise = new WeakMap();
export const AudiFootnoteServiceCreatorV1 = () => {
    const callbacks = new Map();
    const data = new Map();
    const state = new AudiFootnoteServiceState();
    const isInitialized = async () => state.isInitialized();
    const fetchAndAddData = async (apiUrls) => {
        let failCount = 0;
        await Promise.all(apiUrls.map(async (apiUrl) => {
            try {
                const response = await fetchData(apiUrl);
                response.Footnotes.forEach(({ Key, Text }) => {
                    if (!data.has(Key)) {
                        data.set(Key, Text);
                    }
                });
                const newApiUrls = [...new Set([...state.apiUrls, apiUrl])];
                state.apiUrls = newApiUrls;
            }
            catch (e) {
                failCount = failCount + 1;
                console.error(`[footnote-service] Something went wrong when fetch or parsing the data from "${apiUrl}". | Message: ${e}`);
            }
            return true;
        }));
        if (failCount === apiUrls.length) {
            return false;
        }
        return true;
    };
    function create(consumerId) {
        function registerCallback(callback_) {
            if (typeof callback_ !== 'function') {
                throw new Error(`[footnote-service] Bad parameter \`callback\`: Expect function but got ${typeof callback_}.`);
            }
            if (typeof callbacks.get(consumerId) === 'function') {
                throw new Error(`[footnote-service] A callback is already defined for consumer: ${consumerId}.`);
            }
            callbacks.set(consumerId, callback_);
        }
        function unregisterCallback() {
            callbacks.delete(consumerId);
        }
        function update() {
            const dataToArray = mapToArray(data);
            callbacks.forEach((callback) => {
                callback(dataToArray);
            });
        }
        function getData() {
            return mapToArray(data);
        }
        async function addApiUrls(apiUrls) {
            if (!state.initialized) {
                await init(apiUrls);
            }
            else {
                const newApiUrls = [...new Set([...state.apiUrls, ...apiUrls])];
                if (JSON.stringify([...state.apiUrls].sort()) ===
                    JSON.stringify(newApiUrls.sort())) {
                    update();
                }
                else {
                    const success = await fetchAndAddData(apiUrls);
                    if (success) {
                        update();
                    }
                }
            }
        }
        async function init(apiUrls) {
            if (!state.initialized) {
                const success = await fetchAndAddData(apiUrls);
                if (success) {
                    update();
                    state.initialized = true;
                }
                else {
                    state.error = true;
                }
                return getData();
            }
            else {
                addApiUrls(apiUrls);
            }
            return getData();
        }
        function replaceFootNotes(footnotes) {
            footnotes.forEach((footnoteObject) => {
                if (data.has(footnoteObject.Key)) {
                    data.set(footnoteObject.Key, footnoteObject.Text);
                }
            });
            update();
        }
        function addFootNotes(footnotes) {
            footnotes.forEach((footnoteObject) => {
                if (!data.has(footnoteObject.Key)) {
                    data.set(footnoteObject.Key, footnoteObject.Text);
                }
            });
            update();
        }
        function initWithFootnotes(footnotes) {
            if (!state.initialized) {
                if (footnotes) {
                    addFootNotes(footnotes);
                    update();
                    state.initialized = true;
                }
                else {
                    state.error = true;
                }
            }
        }
        return {
            featureService: {
                addApiUrls,
                addFootNotes,
                getData,
                init,
                initWithFootnotes,
                isInitialized,
                registerCallback,
                replaceFootNotes,
                unregisterCallback,
                update,
            },
            unbind: unregisterCallback,
        };
    }
    return {
        create,
    };
};
//# sourceMappingURL=footnote-service.js.map